import Cookies from 'js-cookie'

export const MAJOR_CATALOG_LOGIN_SESSION_KEY = 'ibp_major_catalog_login_ok'

/** 顶栏等组件监听，用于登录/注销后刷新展示（sessionStorage 非响应式） */
export const MAJOR_CATALOG_AUTH_CHANGED_EVENT = 'ibp-major-catalog-auth-changed'

export function notifyMajorCatalogAuthChanged() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(MAJOR_CATALOG_AUTH_CHANGED_EVENT))
}

/** axios 拦截到 resultCode=-9999 时派发，由 App 挂载的全局登录弹窗处理 */
export const GLOBAL_MAJOR_LOGIN_OPEN_EVENT = 'ibp-open-global-major-login'

let _lastGlobalMajorLoginOpenAt = 0

export function notifyGlobalMajorLoginOpen(detail) {
  if (typeof window === 'undefined') return
  const now = Date.now()
  if (now - _lastGlobalMajorLoginOpenAt < 1200) return
  _lastGlobalMajorLoginOpenAt = now
  window.dispatchEvent(
    new CustomEvent(GLOBAL_MAJOR_LOGIN_OPEN_EVENT, {
      detail: detail && typeof detail === 'object' ? detail : {},
    }),
  )
}

export function isMajorCatalogLoginOk() {
  try {
    return sessionStorage.getItem(MAJOR_CATALOG_LOGIN_SESSION_KEY) === '1'
  } catch (e) {
    return false
  }
}

/**
 * 是否要求先登录再进入专业详情页（由 public/courseSsoConfig.js 中 window.MAJOR_DETAIL_LOGIN_REQUIRED 控制）
 * - 未定义或 true：需要登录（与历史行为一致）
 * - false：不校验登录，可直接访问专业详情
 */
export function isMajorDetailLoginRequired() {
  if (typeof window !== 'undefined' && window.MAJOR_DETAIL_LOGIN_REQUIRED === false) {
    return false
  }
  return true
}

export function setMajorCatalogLoginOk() {
  try {
    sessionStorage.setItem(MAJOR_CATALOG_LOGIN_SESSION_KEY, '1')
  } catch (e) {
    /* ignore */
  }
  notifyMajorCatalogAuthChanged()
}

/** 展示用短文案：姓名（账号） */
export function readCatalogUserDisplay() {
  if (!isMajorCatalogLoginOk()) return ''
  try {
    const raw = localStorage.getItem('sys_userInfo')
    if (!raw || raw === '{}') return '已登录'
    const u = JSON.parse(raw)
    const name = u && (u.username || u.name) ? String(u.username || u.name).trim() : ''
    const acc = u && u.account ? String(u.account).trim() : ''
    if (name && acc) return name === acc ? name : `${name}（${acc}）`
    return name || acc || '已登录'
  } catch (e) {
    return '已登录'
  }
}

export function readCatalogUserTitle() {
  if (!isMajorCatalogLoginOk()) return ''
  try {
    const raw = localStorage.getItem('sys_userInfo')
    if (!raw) return ''
    const u = JSON.parse(raw)
    const parts = []
    if (u.username || u.name) parts.push(String(u.username || u.name))
    if (u.account) parts.push('账号：' + u.account)
    if (u.org_name) parts.push(String(u.org_name))
    return parts.join(' · ')
  } catch (e) {
    return readCatalogUserDisplay()
  }
}

export function clearMajorCatalogSession() {
  try {
    sessionStorage.removeItem(MAJOR_CATALOG_LOGIN_SESSION_KEY)
  } catch (e) {
    /* ignore */
  }
  Cookies.remove('access_token')
  Cookies.remove('sys_access_token')
  try {
    localStorage.setItem('sys_userInfo', JSON.stringify({}))
    localStorage.setItem('userInfo', JSON.stringify({}))
  } catch (e) {
    /* ignore */
  }
  notifyMajorCatalogAuthChanged()
}
